import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { FedexSearchFilter } from '../../../../transportation/models/filters/fedex-search-filters';
import { OrderShipmentStatus } from '../../../../models/ordering/enums/order-shipment-status';
import { SearchOrderSummary } from '../../../../models/ordering/search-order-summary';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { AccountingSvc } from '../../../../services/accounting-service';
import { StatusCode } from '../../../../utils/api';
import { FedexFlyout } from '../components/FedexFlyout';
import { FedexOrderRow } from '../components/FedexOrderRow';

export const FedexScene = () => {
   
    const [service] = React.useState(new AccountingSvc());
    const [filterParams, setFilterParams] = React.useState(new FedexSearchFilter());
    const [isFlyoutOpen, setIsFlyoutOpen] = React.useState(false);
    const [orderObj, setOrderObj] = React.useState<any>({});

    const [orders, setOrders] = React.useState(() => {
         const initial = new PagedApiResult<SearchOrderSummary>();
         initial.pagination = filterParams.paginationInfo;
         initial.pagination.reusePaging = true;
         return initial;
    });

    const orderClicked = async (order: SearchOrderSummary) => {

        // Pending orders are greyed out and can't be opened
        if (order.shipmentStatus !== OrderShipmentStatus.Pending) {
            setOrderObj(order);
            setIsFlyoutOpen(true);
        }
    }

    /**
     * Close the flyout
     */
    const closeFlyout = () => {
        setIsFlyoutOpen(false);
        onSearch(filterParams);
    };

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: FedexSearchFilter) => {
        const response = await service.getFedexOrders(filters);
        if (response.status === StatusCode.Success) {
            setOrders(response.data);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new FedexSearchFilter();
        setFilterParams(tmp);
    };

    return <PageContent pageName="[ACCOUNTING] Invoice Search">
        <PageBody>
            <PagedList
                noResultsMessage="No invoices found, please search again."
                searchCallback={ onSearch }
                data={ orders }
                filterProps={ filterParams }
                selectableClass=""
                hideFilterBar={ true }
                onFilterUpdate={ onParamsUpdate }
                onReset={ onParamsReset }
                rowRenderer={(order: SearchOrderSummary) => 
                    <FedexOrderRow
                        key={ order.id }
                        order={ order }          
                        onOrderClick={ orderClicked } 
                    />
                }
        /> 
        <FedexFlyout
                isOpen={isFlyoutOpen}
                onClose={closeFlyout}
                orderObj={orderObj}
        />

    </PageBody>
    </PageContent>;
};
